import { io, Socket } from "socket.io-client";

class SocketManager {
  private socket: Socket | null = null;
  private static instance: SocketManager;

  static getInstance(): SocketManager {
    if (!SocketManager.instance) {
      SocketManager.instance = new SocketManager();
    }
    return SocketManager.instance;
  }

  connect(): Socket {
    if (!this.socket) {
      // Use environment variable or auto-detect origin
      const socketUrl = process.env.NEXT_PUBLIC_SOCKET_URL 
        || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");
      
      console.log("🔌 Connecting to Socket.IO server:", socketUrl);

      this.socket = io(socketUrl, {
        // Remove custom path - use default /socket.io
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });

      this.socket.on("connect", () => {
        console.log("✅ Connected with ID:", this.socket?.id);
      });

      this.socket.on("connect_error", (error) => {
        console.error("❌ Connection error:", error);
      });

      this.socket.on("disconnect", (reason) => {
        console.log("🔌 Disconnected:", reason);
      });
    }
    return this.socket;
  }

  getSocket(): Socket | null {
    return this.socket;
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export const socketManager = SocketManager.getInstance();